import { Box, Typography, useTheme } from '@mui/material';
import { CSVLink as CSVLinkBase } from 'react-csv';
import { AlarmData } from 'src/features/alarms';
import { GraphSeriesType } from '../../types/readings';
import { formatTagDataForExport } from '../../utils/formatTagDataForExport';
import { tooltipItemBox, tooltipItemText, removeBox, StyledMenuPopover } from './style';
import { CloseIcon } from 'src/assets/icons/CloseIcon';
import { ExportIcon } from 'src/assets/icons/ExportIcon';
import { RefreshIcon } from 'src/assets/icons/RefreshIcon';

type Props = {
  htmlElement: any;
  onClosePopover: () => void;
  onRemoveHandler: () => void;
  pointChartData?: GraphSeriesType[];
  alarms?: AlarmData[];
  handleDownloadPNGClick: () => void;
  onSelectDataHandler: () => void;
};

export const MenuPopoverOptions = ({
  htmlElement,
  onClosePopover,
  pointChartData,
  handleDownloadPNGClick,
  onRemoveHandler,
  onSelectDataHandler,
}: Props) => {
  const tagForExport = pointChartData ? formatTagDataForExport(pointChartData) : [];

  const theme = useTheme();

  return (
    <StyledMenuPopover open={htmlElement} onClose={onClosePopover} arrow="right-top" theme={theme}>
      <Box sx={{ padding: '0.3rem 1rem' }}>
        <Box sx={tooltipItemBox} data-sm="select-data" onClick={onSelectDataHandler}>
          <RefreshIcon />
          <Typography sx={tooltipItemText}>Select data</Typography>
        </Box>

        <CSVLinkBase
          data-sm="download-csv"
          onClick={onClosePopover}
          style={{ textDecoration: 'none', color: 'inherit' }}
          data={tagForExport || []}
        >
          <Box sx={tooltipItemBox}>
            <ExportIcon width={10} height={10} />
            <Typography sx={tooltipItemText}>Download CSV</Typography>
          </Box>
        </CSVLinkBase>

        <Box sx={tooltipItemBox} onClick={handleDownloadPNGClick} data-sm="download-png">
          <ExportIcon width={10} height={10} />
          <Typography sx={tooltipItemText}>Download PNG</Typography>
        </Box>
        <Box sx={removeBox} onClick={onRemoveHandler} data-sm="remove-button">
          <CloseIcon width={10} />
          <Typography sx={tooltipItemText}>Remove</Typography>
        </Box>
      </Box>
    </StyledMenuPopover>
  );
};
